import { subHours, lightFormat, parseISO } from "date-fns"
import { zonedTimeToUtc } from "date-fns-tz"

function normalizeDate(date: string, hours?: number) {
  const parsedDate = parseISO(date);
  const znDate = zonedTimeToUtc(parsedDate, 'America/Sao_Paulo');
  return hours ? subHours(znDate, hours) : znDate
}

function format(date: string, format?: string, tz: number = 0) {
  const formatted = lightFormat(normalizeDate(date, tz), format || 'dd/MM/yyyy')
  return formatted
}

function formatDate(date: string, withHours: boolean = false, tz: number = 0, noDate: string = '') {
  const stringDate = withHours ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy'
  if (date) {
    return format(date, stringDate, tz)
  }
  return noDate
}

function formatBirthDate(date: string, withHours: boolean = false, tz: number = -3, noDate: string = '') {
  const stringDate = withHours ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy'
  if (date) {
    return format(date, stringDate, tz)
  }
  return noDate
}

function formatWithCallback(date: string, pattern: string = 'yyyy-MM-dd', tz: number = -3) {
  if (date) {
    try {
      return format(date, pattern, tz)
    } catch (error) {
      return ''
    }
  }
}

function getNextClosestDate(date: Date) {
  const options = [5, 10, 15, 20, 25, 30];
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();

  let nextDay = options.find(option => option > day);

  if (nextDay === undefined) {
    nextDay = options[0];
    date.setMonth(month + 1);
  }

  date.setDate(nextDay);

  if (date.getMonth() !== month) {
    date.setMonth(month);
    date.setFullYear(year + 1);
  }

  return {
    date,
    datePay: `Venc. dia ${nextDay}`
  };
}

function calculateAge(birthDate: string): string {
  const birth = new Date(birthDate);
  const today = new Date();

  // Calculate the age in years
  let age = today.getFullYear() - birth.getFullYear();

  // Adjust age if the birthday hasn't occurred yet this year
  const monthDiff = today.getMonth() - birth.getMonth();
  const dayDiff = today.getDate() - birth.getDate();

  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--; // If birthday hasn't occurred yet this year
  }

  return `${age} anos`;
}

export {
  format,
  formatDate,
  formatBirthDate,
  normalizeDate,
  formatWithCallback,
  getNextClosestDate,
  calculateAge
} 